import { useState } from "react";
import { useAllActivities } from "../../../js/api/activity-feed/get-activities";
import { useAllActivityFeed } from "../../all-activity-feed";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { ActivityFeed } from "./activity-feed";
import { Action } from "../shared/action";
import { SharedIcon } from "../shared/shared-icon";

export const AllActivityFeedWrapper = () => {
  const propsData = useAllActivityFeed();
  const [itemCount] = useState(() => 20);
  const [beforeTimestamp] = useState(new Date().toISOString());
  const { data, isLoading, isError, isFetching, hasNextPage, fetchNextPage } =
    useAllActivities({
      itemCount,
      beforeTimestamp,
    });

  const apiData = {
    activityFeedsList: data?.allActivities || [],
  };

  const isEmpty = !isLoading && !isFetching && data?.allActivities.length === 0;

  if (isLoading) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  return (
    <>
      {isEmpty && (
        <div className="saved-colors-loading-container saved-colors-loading-container--no-top-padding">
          {propsData.emptyActivitiesMessage}
        </div>
      )}
      {!isEmpty && (
        <>
          <ActivityFeed
            apiData={apiData}
            contextData={propsData}
          />
          {hasNextPage && (
            <Action
              onClick={() => fetchNextPage()}
              disabled={isFetching}
              className="button activity-feed__pagination-button"
            >
              {isFetching && (
                <SharedIcon
                  iconName="#sprite-spinner"
                  className="animate-spin"
                />
              )}
              {!isFetching && propsData.showMore}
            </Action>
          )}
        </>
      )}
    </>
  );
};
